import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  RadioGroup,
  Radio,
  Typography,
  FormControl,
  FormControlLabel,
  FormLabel,
  FormGroup,
} from '@material-ui/core'
import { downloadReportCitizenRegs, downloadReportPartnerProgram } from 'store/analytics/citizenAppSlice'
import { Button, Wrapper, Select } from 'sputnik-ui'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'


export default function PartnerProgramAnalytics({ 
  formatDate, 
  BlueRadio, 
  ResDiv, 
  Content, 
  SearchIcon, 
  StartEndDatesComponent,
  fetchLocalities,
  setLocalityFilter,
  localities,
  localityFilter,
  selectedCompanyUuid,
  CalendarIcon,  ...props }) {
  const dispatch = useDispatch()
  const { t } = useTranslation(['analytics'])
  const programStatus = true
  const [monthAgo, setMonthAgo] = useState('')
  const [minDate, setMinDate] = useState(null)
  const [isChecked, setIsChecked] = useState(true)

  const formik = useFormik({
    initialValues: {
      download_type: 'xlsx',
      start_date: formatDate(monthAgo),
      end_date: formatDate(new Date()),
      locality_uuid: undefined,
      gilad: true,
      company_uuid: selectedCompanyUuid,
    },
    onSubmit: (values) => {
      dispatch(downloadReportCitizenRegs(values))
    },
  })

  useEffect(() => {
      let kek = new Date()
      kek.setMonth(kek.getMonth() - 1)
      setMinDate(null)
  
      if (dayjs(kek) < dayjs('2021-08-01') && isChecked) {
        kek = '2021-08-01'
        setMinDate('2021-08-01')
      }
      if (isChecked) {
        setMinDate('2021-08-01')
      }
      setMonthAgo(kek)
    }, [isChecked])
  
  useEffect(() => {
    formik.setFieldValue('start_date', formatDate(monthAgo))
  }, [minDate])
  
  return (
     <>
      <Typography
        variant="h5"
        style={{ marginTop: '2rem', marginBottom: '1rem' }}
      >
        {t('analytics:title')}
      </Typography>
        <form onSubmit={formik.handleSubmit}>
          <Wrapper
            shadow={false}
            style={{ flexDirection: 'column', width: 'fit-content' }}
          >
            <Typography variant="h6" style={{ marginBottom: '1rem' }}>
              {t('analytics:settings')}
            </Typography>
            <ResDiv>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <FormControl
                  component="fieldset"
                  style={{
                    width: '100%',
                    minWidth: 300,
                  }}
                >
                  <Select
                    // async
                    // loadOptions={options}
                    name="locality_uuid"
                    options={localities}
                    isMulti={false}
                    // isClearable={false}
                    cacheOptions
                    defaultOptions
                    value={localityFilter}
                    onChange={(o) => {
                      dispatch(setLocalityFilter(o))
                      formik.setFieldValue('locality_uuid', o.value)
                    }}
                    placeholder={t('analytics:address_placeholder')}
                    style={{ width: '100%' }}
                  />
  
                  <Typography
                    variant="h6"
                    color="textSecondary"
                    style={{ marginTop: '1rem', fontWeight: 400 }}
                  >
                    {t('analytics:key_indicators')}
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <BlueRadio
                          checked={formik.values.gilad}
                          onChange={(e) => {
                            formik.setFieldValue('gilad', true)
                            setIsChecked(true)
                          }}
                        />
                      }
                      label={t('analytics:intecom_income')}
                      name="gilad"
                    />
                    {/* <FormControlLabel
                      control={
                        <BlueRadio
                          checked={!formik.values.gilad}
                          onChange={(e) => {
                            formik.setFieldValue('gilad', false)
                            setIsChecked(false)
                          }}
                        />
                      }
                      label={t('analytics:download_default')}
                      name="gilad"
                    /> */}
                  </FormGroup>
                </FormControl>
              </div>
  
              <Content>
                <StartEndDatesComponent 
                handleChangeStartDate={formik.handleChange} 
                handleChangeEndDate={formik.handleChange} 
                minDate={formatDate(minDate)}
                values={formik.values}
                />
                <Typography variant="h6" style={{ margin: '1rem 0' }}>
                  {t('analytics:uploading_data')}
                </Typography>
  
                <FormControl>
                  <FormLabel component="legend">
                    {t('analytics:data_format')}
                  </FormLabel>
                  <RadioGroup
                    onChange={formik.handleChange}
                    value={formik.values.download_type}
                    name="download_type"
                  >
                    <FormControlLabel
                        control={<Radio />}
                        value="xlsx"
                        label=".xlsx"
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="csv"
                      label=".csv"
                    />
                  </RadioGroup>
                </FormControl>
                <Button
                  type="submit"
                  primary
                  style={{ marginTop: '1rem', marginRight: 'auto' }}
                >
                  {t('analytics:export_data')}
                </Button>
              </Content>
            </ResDiv>
          </Wrapper>
        </form>
    </>
  )
    
}
